import { 
	GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STANDARDS, 
	GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STANDARD,
	CREATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STANDARD,
	UPDATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STANDARD,
	DESTROY_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STANDARD,
} from "./actions"

export function ProjectQaWeldingInspectionsWeldingStandardsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STANDARDS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STANDARD}_FULFILLED`:
		case `${CREATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STANDARD}_FULFILLED`:
		case `${UPDATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STANDARD}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STANDARD}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectQaWeldingInspectionsWeldingStandardsReducer } from "modules/project/qa/welding_inspections/welding_standards/reducer"

// project_qa_welding_inspections_welding_standards:ProjectQaWeldingInspectionsWeldingStandardsReducer,
